import {USER_AUTHORITY_SERVICE} from "main";

class RouterConfig {
    constructor($routeProvider) {
        let allRoutes = USER_AUTHORITY_SERVICE.getPermittedModulesRouterConfigs();
        for (const moduleRoutes of allRoutes) {
            for (const routerConfig of moduleRoutes) {
                // routerConfig[0] = PARENT_ROUTE_NAME + routerConfig[0];
                $routeProvider.when(...routerConfig);
            }
        }

        $routeProvider
            .otherwise({
                redirectTo: "/customers"
            });
    }
}

export const RouterConfigInstance = ['$routeProvider', RouterConfig];
